module.exports = __webpack_public_path__ + "static/Widen-3e3b4aac137d7f6d59d54b566c641347.png";